class ApiPostHelper {
    static postData = async (url, token, data) => {
        try {
            console.log(url);
            const response = await fetch(
                url,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: data,
                }
            );

            if (response.status === 401) {
                throw new Error('Unauthorized: Check your Bearer token');
            }

            if (!response.ok) {
                throw new Error(`Failed to fetch data. Status: ${response.status}`);
            }

            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('Error making POST request:', error.message);
            throw error;
        }
    };
}

export default ApiPostHelper;